import { render, staticRenderFns } from "./PinBoard.vue?vue&type=template&id=1d53a9aa&"
import script from "./PinBoard.vue?vue&type=script&lang=ts&"
export * from "./PinBoard.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./PinBoard.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports